var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "b-jumbotron",
        {
          staticStyle: { padding: "0 50px" },
          attrs: {
            "bg-variant": "light",
            "text-variant": "dark",
            "border-variant": "dark",
            header: _vm.moduleSession.moduleName
          }
        },
        [
          _c(
            "template",
            { staticClass: "module-session-info-jum", slot: "lead" },
            [
              _c("span", { style: _vm.msInfoJumKey }, [_vm._v("Time: ")]),
              _c("span", { style: _vm.msInfoContent }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm
                        .$moment(_vm.moduleSession.sessionTimeRaw, [
                          "DD/MM/YYYY HH:mm",
                          "DD-MM-YYYY HH:mm",
                          _vm.$moment.ISO_8601
                        ])
                        .format("DD-MM-YYYY HH:mm")
                    ) +
                    "\n      "
                )
              ]),
              _vm._v(" |\n      "),
              _c("span", { style: _vm.msInfoJumKey }, [_vm._v("Language: ")]),
              _c("span", { style: _vm.msInfoContent }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.moduleSession.language) + "\n      "
                )
              ]),
              _vm._v(" |\n      "),
              _c("span", { style: _vm.msInfoJumKey }, [_vm._v("Trainer: ")]),
              _c("span", { style: _vm.msInfoContent }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.moduleSession.trainerName) +
                    "\n      "
                )
              ]),
              _vm._v(" |\n      "),
              _c("span", { style: _vm.msInfoJumKey }, [_vm._v("Seat Taken: ")]),
              _c("span", { style: _vm.msInfoContent }, [
                _vm._v(
                  "\n\n        " +
                    _vm._s(_vm.moduleSeatTaken.seatTaken) +
                    "\n      "
                )
              ])
            ]
          ),
          _c("hr"),
          _c("b-col", [
            _c("h5", { staticStyle: { color: "red" } }, [_vm._v("Attention!")]),
            _c("h6", { staticStyle: { color: "#184167" } }, [
              _vm._v(
                '-For New Trainee: ① Press "Upload Files" button ➁ Browse the file & click "Upload Files" again ③ Press "Submit For Approval" button to confirm booking.'
              )
            ]),
            _c("h6", { staticStyle: { color: "#184167" } }, [
              _vm._v(
                '-For Existing Trainee: ① Press "Upload Files" button  ➁ Press "Submit For Approval" button to confirm booking.'
              )
            ])
          ])
        ],
        2
      ),
      _c("AddApplicant", { on: { addApplicant: _vm.addApplicant } }),
      _c(
        "b-row",
        { staticClass: "applicant-list", attrs: { "align-h": "between" } },
        [
          _c(
            "b-col",
            [_c("ApplicantList", { on: { cancelBooking: _vm.cancelBooking } })],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-61d0f3a7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61d0f3a7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/mainPage/_mid.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-61d0f3a7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/mainPage/_mid.vue
// module chunks = 8